/** @jsx h */
import { h, Component, Fragment } from 'preact'
import t from '../../../utils/translate'
import * as analytics from '../../../utils/analytics'
import ThumbsUpIcon from '../icons/ThumbsUpIcon'
import ThumbsDownIcon from '../icons/ThumbsDownIcon'
import Option from './Option'

const BEFORE_FEEDBACK = -1
const POSITIVE_FEEDBACK = 0
const NEGATIVE_FEEDBACK = 1
const SENT_FEEDBACK = 2

export default class Feedback extends Component {
  constructor (props) {
    super(props)
    const { context } = this.props
    // TODO: Standardise call to replace with context and edit prefills for each feedback context e.g. experience, story
    const ctx = context === 'Directory' ? 'directory.' : ''
    this.state = {
      anyChecked: false,
      result: BEFORE_FEEDBACK,
      positiveOptionsList: [
        { key: 'yes_understand', value: t(`feedback.options.${ctx}yes_understand`) },
        { key: 'yes_trust', value: t(`feedback.options.${ctx}yes_trust`) },
        { key: 'yes_love', value: t(`feedback.options.${ctx}yes_love`) },
        { key: 'yes_help', value: t(`feedback.options.${ctx}yes_help`) },
        { key: 'yes_none', value: t(`feedback.options.${ctx}yes_none`) }
      ],
      negativeOptionsList: [
        { key: 'no_info', value: t(`feedback.options.${ctx}no_info`) },
        { key: 'no_evidence', value: t(`feedback.options.${ctx}no_evidence`) },
        { key: 'no_initiative', value: t(`feedback.options.${ctx}no_initiative`) },
        { key: 'no_help', value: t(`feedback.options.${ctx}no_help`) },
        { key: 'no_none', value: t(`feedback.options.${ctx}no_none`) }
      ]
    }
  }

  handleClickPositive = () => {
    const { result } = this.state
    const { context } = this.props
    if (result === NEGATIVE_FEEDBACK) {
      this.uncheckAll()
    }
    if (result === BEFORE_FEEDBACK) {
      if (context === 'Directory') {
        this.trackWithDirectoryGA('feedback', 'clicked', 'positive')
      } else {
        this.trackWithSegment('feedback', 'clicked', 'positive')
        this.trackWithGA('feedback_positive')
      }
    }
    this.setState({ result: POSITIVE_FEEDBACK })
    setTimeout(() => {
      const val = document.getElementById(`${context || ''} feedback-form`)
      val.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }, 200)
  }

  handleClickNegative = () => {
    const { result } = this.state
    const { context } = this.props
    if (result === POSITIVE_FEEDBACK) {
      this.uncheckAll()
    }
    if (result === BEFORE_FEEDBACK) {
      if (context === 'Directory') {
        this.trackWithDirectoryGA('feedback', 'clicked', 'negative')
      } else {
        this.trackWithSegment('feedback', 'clicked', 'negative')
        this.trackWithGA('feedback_negative')
      }
    }
    this.setState({ result: NEGATIVE_FEEDBACK })
    setTimeout(() => {
      const val = document.getElementById(`${context || ''} feedback-form`)
      val.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }, 200)
  }

  handleChange = (event) => {
    const noneCheckbox = document.querySelector('#yes_none, #no_none')
    const allOtherCheckboxes = document.querySelectorAll('[type="checkbox"]:not(#yes_none, #no_none)')
    if (noneCheckbox.checked) {
      allOtherCheckboxes.forEach(cb => {
        cb.checked = false
        cb.disabled = true
      })
    } else {
      allOtherCheckboxes.forEach(cb => {
        cb.disabled = false
      })
    }

    this.setState({ anyChecked: Array.from(document.querySelectorAll('[type=checkbox]')).some(x => x.checked) })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { result, positiveOptionsList, negativeOptionsList } = this.state
    const { context } = this.props
    const optionsCheckedArray = []
    const optionsArray = result === POSITIVE_FEEDBACK ? positiveOptionsList : negativeOptionsList
    optionsArray.forEach((el) => { if (document.getElementById(el.key).checked) { optionsCheckedArray.push(el.key) } })
    if (context === 'Directory') {
      this.trackWithDirectoryGA('feedbackDetails', 'submitted', optionsCheckedArray.join(' , '))
    } else {
      this.trackWithSegment('feedbackDetails', 'submitted', optionsCheckedArray.join(' , '))
    }
    this.setState({ result: SENT_FEEDBACK })
  }

  uncheckAll = () => {
    document.querySelector('form').reset()
    this.setState({ anyChecked: false })
  }

  trackWithGA = (event) => {
    const { analyticsContext, analyticsName } = this.props
    analytics.track(event, {
      eventAction: analyticsName,
      eventLabel: analyticsContext
    })
  }

  trackWithSegment = (object, event, value) => {
    const { analyticsContext, analyticsName } = this.props
    const brandName = analyticsContext ? analyticsContext.split(' / ')[0] : analyticsContext
    const subjectName = analyticsContext ? analyticsContext.split(' / ')[1] : analyticsContext
    analytics.track(`${object}_${event}`, {
      object,
      action: event,
      brand_name: brandName,
      subject_name: subjectName,
      subject_value: analyticsName,
      value
    }, { adapter: 'segment' })
  }

  trackWithDirectoryGA = (object, event, value) => {
    const { brandName } = this.props
    analytics.track(`${object}_${event}`, {
      object,
      action: event,
      brand_name: brandName,
      subject_value: value
    }, { adapter: 'gtm' })
  }

  render () {
    const { context, dark } = this.props
    const { anyChecked, result, positiveOptionsList, negativeOptionsList } = this.state

    const buttonStyle = dark ? 'Feedback-button--dark' : ''

    const isBefore = result === BEFORE_FEEDBACK
    const isPositive = result === POSITIVE_FEEDBACK
    const isNegative = result === NEGATIVE_FEEDBACK
    const isSent = result === SENT_FEEDBACK
    const optionArray = isPositive ? positiveOptionsList : negativeOptionsList

    return (
      <>
        {!isSent &&
          <p class='BodyUI--emphasis text-center'>{t('feedback.cta')}</p>}
        <p class='BodyUI--emphasis text-center' aria-live='assertive' role='alert'>{isSent ? t('feedback.positive_feedback') : null}</p>
        <div class={`Feedback ${dark ? 'Feedback--dark' : ''} ${isSent ? 'Feedback--hidden' : ''}`} aria-hidden={isSent}>
          <div class='u-marginTop8'>
            <button
              class={`${buttonStyle} Feedback-button Feedback-button--positive ${isSent ? 'Feedback-button--hidden' : ''}`}
              data-state={isPositive ? 'active' : ''}
              type='button'
              onClick={this.handleClickPositive}
            >
              <ThumbsUpIcon />
            </button>
            <button
              class={`${buttonStyle} Feedback-button Feedback-button--negative ${isSent ? 'Feedback-button--hidden' : ''}`}
              data-state={isNegative ? 'active' : ''}
              type='button'
              onClick={this.handleClickNegative}
            >
              <ThumbsDownIcon />
            </button>
          </div>
          <div class={`u-marginTop8 ${!isSent ? 'Triangle-div' : 'Triangle-div--hidden'}`}>
            <div class={`Triangle ${isPositive ? '' : 'Triangle--hidden'}`} />
            <div class={`Triangle ${isNegative ? '' : 'Triangle--hidden'}`} />
          </div>
          <form
            id={`${context || ''} feedback-form`}
            class={`simple-form Form ${isBefore || isSent ? 'Feedback-form--hidden' : 'Feedback-form'}`}
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
            aria-hidden={isBefore}
          >
            <fieldset>
              <legend class='sr-only'>{t('feedback.cta')}</legend>
              <ul class='Form-itemGroup'>
                {optionArray.map(({ key, value }) =>
                  <Option id={key} key={key} value={value} />)}
              </ul>
            </fieldset>
            <input
              id='submit-button'
              type='submit'
              value='Send Feedback'
              class={`Action ${isNegative || isPositive ? 'Feedback-submit' : 'Feedback-submit--hidden'}`}
              disabled={!anyChecked}
              aria-hidden={isSent}
            />
          </form>
        </div>
      </>
    )
  }
}
